import { defineMessage } from 'services/localization';

export const messages = {
    requestToSalesSuccessMessage: defineMessage('your_request_has_been_s_ill_contact_you_shortly'),
    requestToSalesFailedMessage: defineMessage('oops_something_went_wrong_1'),
};
